import { createFileRoute, notFound } from '@tanstack/react-router'
import { OccasionPageViewModel } from '@/components/occasion/occasion-page/occasion-page.view-model'
import { NotFoundFloraViewModel } from '@/components/shared/not-found-flora/not-found-flora.view-model'
import { findOccasionById } from '@/constants/occasions'
import { SITE_BASE_URL } from '@/constants/site'
import { buildPageMeta } from '@/lib/seo/build-page-meta'
import { occasionIdSchema } from '@/schemas/occasion.schema'
import { productsQueryOptions } from '@/services/products/use-products'

export const Route = createFileRoute('/_editorial/ocasioes/$ocasiao')({
  loader: ({ context, params }) => {
    const parsedOcasiao = occasionIdSchema.safeParse(params.ocasiao)
    if (!parsedOcasiao.success) {
      throw notFound()
    }
    return context.queryClient.ensureQueryData(
      productsQueryOptions.byOccasion(parsedOcasiao.data),
    )
  },
  head: ({ params }) => {
    const parsedOcasiao = occasionIdSchema.safeParse(params.ocasiao)
    if (!parsedOcasiao.success) {
      return {}
    }

    const occasion = findOccasionById(parsedOcasiao.data)
    if (!occasion) {
      return {}
    }

    return {
      ...buildPageMeta({
        title: occasion.seoTitle,
        description: occasion.seoDescription,
        path: `/ocasioes/${occasion.id}`,
      }),
      scripts: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Início',
                item: SITE_BASE_URL,
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: occasion.title,
                item: `${SITE_BASE_URL}/ocasioes/${occasion.id}`,
              },
            ],
          }),
        },
      ],
    }
  },
  notFoundComponent: NotFoundFloraViewModel,
  component: OcasiaoRouteComponent,
})

function OcasiaoRouteComponent() {
  const { ocasiao } = Route.useParams()
  const occasionId = occasionIdSchema.parse(ocasiao)
  const occasion = findOccasionById(occasionId)
  if (!occasion) {
    throw notFound()
  }
  return <OccasionPageViewModel occasion={occasion} />
}
